import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../common/state';
import { changeMinArea, changeMaxArea, TArea } from '../../../../state/advanced/area';
import { IAreaStateProps, IAreaDispatchProps, IAreaOwnProps, Area } from './area';

export function mapStateToProps(state: IAppState): IAreaStateProps {
  return {
    totalAreaMin: state.filters.jsonQuery.total_area && state.filters.jsonQuery.total_area.value.gte,
    totalAreaMax: state.filters.jsonQuery.total_area && state.filters.jsonQuery.total_area.value.lte,
    roomAreaMin: state.filters.jsonQuery.room_area && state.filters.jsonQuery.room_area.value.gte,
    roomAreaMax: state.filters.jsonQuery.room_area && state.filters.jsonQuery.room_area.value.lte,
    livingAreaMin: state.filters.jsonQuery.living_area && state.filters.jsonQuery.living_area.value.gte,
    livingAreaMax: state.filters.jsonQuery.living_area && state.filters.jsonQuery.living_area.value.lte,
    kitchenAreaMin: state.filters.jsonQuery.kitchen && state.filters.jsonQuery.kitchen.value.gte,
    kitchenAreaMax: state.filters.jsonQuery.kitchen && state.filters.jsonQuery.kitchen.value.lte,
  };
}

export function mapDispatchToProps(dispatch: Dispatch): IAreaDispatchProps {
  return {
    onMinAreaChanged: (param: TArea, value: number | undefined) => {
      dispatch(changeMinArea(param, value));
    },
    onMaxAreaChanged: (param: TArea, value: number | undefined) => {
      dispatch(changeMaxArea(param, value));
    },
  };
}

export const AreaContainer = connect<IAreaStateProps, IAreaDispatchProps, IAreaOwnProps>(
  mapStateToProps,
  mapDispatchToProps,
)(Area);
